export const getArrayLengthPlusOne = (arr: unknown[]) => {
  const lastId = arr?.length || 0;
  return lastId + 1;
};
